<template>
	<v-container class="mt-4 px-5" fluid>
	  <v-row v-if="( [18,19].includes( getdatosUsuarioERPERP.idpuesto ) && accesos.includes( getdatosUsuarioERPERP.iderp ) ) || ![18,19].includes( getdatosUsuarioERPERP.idpuesto )">
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  			<v-card-title primary-title>
	  		    <span class="text-subtitle-1">Coordinación de sucursales</span>
            <v-spacer></v-spacer>

            <v-btn
              class="mr-2"
              small dark color="green"
              @click="exportExcel( filterEmpleados  , 'coordi_sucursales')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <!-- Boton para cagar la información de los catalagos del ERP en el LMS -->
            <v-tooltip bottom v-if="accesos.includes( getdatosUsuarioERPERP.iderp )">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2" 
                  small 
                  color="black"
                  @click="dialogRolados.estatus = true"
                  tile
                >
                  <v-icon small>mdi-account-alert</v-icon>
                </v-btn>
              </template>
              <span>Teachers no rolados</span>
            </v-tooltip>

            <!-- <v-btn
              color="secondary"
              dark
              class="mr-2"
              @click="dialogVacantes.estatus =true"
              small
              tile
            >
              Vacantes
            </v-btn> -->

	  		    <v-btn
              color="primary"
              dark
              @click="initialize"
              small
              tile
            >
              Actualizar
            </v-btn>

	  		  </v-card-title>

          <v-card-text>

            <!-- FILTRO DE BUSCAQUEDA Y DE FECHA, BOTONES DE DESCARGA -->
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  label="Fecha"
                  dense
                  filled
                  v-model="fecha"
                  class="ms-4"
                  type="date"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- FILTRO DE LOS RADIO BUTTON -->
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <label>Elige una escuela</label>
                <v-radio-group
                  v-model="escuela"
                  row
                  hide-details
                >
                  <v-radio
                    label="Inbi"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Fast"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    label="Todas"
                    :value="3"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <label>Elige una opción para la sucursal</label>
                <v-radio-group
                  v-model="validada"
                  row
                  hide-details
                >
                  <v-radio
                    label="Validada"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Sin Validar"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    label="Sin huella"
                    :value="4"
                  ></v-radio>
                  <v-radio
                    label="Todas"
                    :value="3"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <label>Elige el estatus de la huella</label>
                <v-radio-group
                  v-model="opHuella"
                  row
                  hide-details
                >
                  <v-radio
                    label="Con"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Sin"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    label="Todas"
                    :value="3"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <label>Estatus huella Teacher</label>
                <v-radio-group
                  v-model="opHuellaTeacher"
                  row
                  hide-details
                >
                  <v-radio
                    label="Con"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Sin"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    label="Todas"
                    :value="3"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <label>Elige un turno</label>
                <v-radio-group
                  v-model="opTurno"
                  row
                  hide-details
                >
                  <v-radio
                    label="Matutino"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Vespertino"
                    :value="2"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <!-- KPIS -->
            <v-row>
              <v-col cols="12" class="mb-2">
                <b>Planteles:</b> {{ plantelesKpi.length }}<br/>
                <b>Validadas:</b> {{ plantelesKpi.filter( el => el.confirmado && el.abrio ).length }}<br/>
                <b>Faltan:</b> {{ plantelesKpi.filter( el => !el.confirmado && el.abrio ).length }}<br/>
                <b>Avance:</b> {{ plantelesKpi.length ? ( ( plantelesKpi.filter( el => el.confirmado && el.abrio ).length / plantelesKpi.length ) * 100 ).toFixed( 2 ) : '0.00' }}<br/>
              </v-col>
            </v-row>

  				  <v-data-table
  				    :headers="headers"
  				    :items="filterEmpleados"
  				    class="elevation-0"
              :search="search"
              dense
              :items-per-page="empleados.length"
              hide-default-footer
  				  >

              <template v-slot:item.plantel="{ item }">
                <div v-if="item.esExtension" class="py-1 pl-4">
                  <div class="caption grey--text">↳ {{ item.plantel_madre }}</div>
                  <v-chip x-small class="mr-1" color="blue-grey lighten-3">Extensión</v-chip>
                  <strong>{{ item.plantel }}</strong>
                </div>
                <div v-else class="py-1">
                  <span>{{ item.plantel }}</span>
                </div>
              </template>

              <!-- Validación de apertura -->
              <template v-slot:item.apertura="{ item }">

                <!-- Si ya está abierto y está validado, se pone en verde -->
                <v-chip small
                  :color="item.confirmado ? 'green' : item.abrio ? 'yellow' : 'red'"
                  :dark="item.confirmado ? true : item.abrio ? false : true">
                  {{ item.apertura }}
                </v-chip>

                <br/>

                <!-- Este chip es para cuando ya se abrio, pero no está confirmado -->
                <v-chip class="my-4" small color="orange" v-if="!item.esExtension && (item.abrio && !item.confirmado || [16, 17].includes(item.idplantel) && !item.confirmado)" dark @click=" plantelSeleccionado = item , dialogValidarSucursal = true">
                  Clic para validar
                </v-chip>

                <v-chip class="my-4" small color="green" v-if="!item.esExtension && (item.abrio && item.confirmado || [16, 17].includes(item.idplantel) && item.confirmado)" dark @click="plantelSeleccionado = item.confirmado, dialgoApertura = true">
                  Clic para ver
                </v-chip>

              </template>

              <!-- Validación de apertura -->
              <template v-slot:item.corteCaja="{ item }">
                <v-chip v-if="item.esExtension" small outlined disabled>No aplica</v-chip>
                <template v-else>
                <v-tooltip bottom v-if="item.corteCaja">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      color="green"
                      dark
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      Validado
                    </v-chip>
                  </template>
                  <span v-if="item.corteCaja">
                    Aceptó: {{ item.corteCaja.nombre_completo }}
                    <br/>
                    Hora: {{ item.corteCaja.fecha_creacion }}
                  </span>
                </v-tooltip>

                <v-chip class="my-4" small color="yellow" v-else @click="validarCorte = true, plantelSeleccionado = item">
                  Clic para validar
                </v-chip>
                </template>
              </template>

              <!-- Responsable de clases -->
              <template v-slot:item.responsableClases="{ item }">
                <span
                  v-for="( responsable, i ) in (item.responsableClases || item.responsable_clases || [])"
                  :key="i"
                >
                  <v-chip
                    small
                    color="green"
                    dark
                    class="ma-1"
                  >
                    <v-icon left>mdi-account-school</v-icon>
                    {{ responsable.nombre_completo || responsable.nombre_usuario }}
                    <v-icon class="ml-2" @click.stop="eliminarResponsableClases( responsable, item )">mdi-close</v-icon>
                  </v-chip>
                </span>
                <v-chip
                  v-if="!(item.responsableClases || item.responsable_clases || []).length"
                  small
                  color="red"
                  dark
                  @click="agregarResponsableClases( item )"
                >
                  Agregar
                </v-chip>
              </template>

              <!-- Validar que los teachers estén completos -->
              <template v-slot:item.validaTeachers="{ item }">
                <v-chip v-if="item.esExtension" small outlined disabled>No aplica</v-chip>
                <template v-else>
                <v-tooltip bottom v-if="item.plantelCompleto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      color="green"
                      dark
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      Validado
                    </v-chip>
                  </template>
                  <span v-if="item.plantelCompleto">
                    Aceptó: {{ item.plantelCompleto.nombre_completo }}
                    <br/>
                    Hora: {{ item.plantelCompleto.fecha_creacion }}
                  </span>
                </v-tooltip>

                <v-chip class="my-4"
                  small
                  :color="item.teachers_completos ? 'yellow' : 'red'"
                  v-else-if="opHuellaTeacher == 1 && item.teachers_completos "
                  @click="dialogAsistenciasTeacher = true, plantelSeleccionado = item, teacherAsistencia = item.teachers"
                >
                  Clic para validar
                </v-chip>

                <v-chip class="my-4"
                  small
                  :color="item.teachers_completos ? 'yellow' : 'red'"
                  v-else-if="opHuellaTeacher == 2 && !item.teachers_completos "
                  @click="dialogAsistenciasTeacher = true, plantelSeleccionado = item, teacherAsistencia = item.teachers"
                >
                  Clic para validar
                </v-chip>

                <v-chip class="my-4"
                  small
                  :color="item.teachers_completos ? 'yellow' : 'red'"
                  v-else-if="opHuellaTeacher == 3"
                  @click="dialogAsistenciasTeacher = true, plantelSeleccionado = item, teacherAsistencia = item.teachers"
                >
                  Clic para validar
                </v-chip>
                </template>
              </template>

              <!-- Validación de las coordinadoras -->
              <template v-slot:item.coordi="{ item }">

                <span
                  v-for="( coordi, i ) in item.coordi"
                  :key="i"
                >
                  <v-chip
                    small
                    :color="coordi.asistencia == 1 ? 'green' : 'red'"
                    @click="((encargadas_telefonos = [coordi]),(reemplazoAux = coordi.reemplazo), (dialogTelefonos = true), ( plantelSeleccionado = item ))"
                  	dark
                    v-if="( opHuella == 1 && coordi.asistencia == 1 ) || ( opHuella == 2 && !coordi.asistencia ) || opHuella == 3"
                  >
                  	  <v-icon left v-if="coordi.asistencia == 1">mdi-circle-medium</v-icon>
                      <v-icon left v-if="coordi.reemplazo == 1">mdi-skull</v-icon>
                  	  {{ coordi.nombre_usuario }}
                      <v-icon class="ml-2" @click.stop="eliminarCoordi( coordi, item )">mdi-close</v-icon>
                  </v-chip>
                </span>
                <v-chip v-if="!item.coordi.length" small color="red" dark @click="agregarCoordi( item )">
              		Agregar
              	</v-chip>
              </template>

              <!-- Validación de los Teacher Líder -->
              <template v-slot:item.teacherslider="{ item }">
                <span
                  v-for="( teacher, i ) in item.teacherslider"
                  :key="i"
                >
                  <v-chip
                    small
                    :color="teacher.asistencia == 1 ? 'green' : 'red'"
                    @click="(encargadas_telefonos = [teacher]),(reemplazoAux = teacher.reemplazo), (dialogTelefonos = true), ( plantelSeleccionado = item )"
                    dark
                    v-if="( opHuella == 1 && teacher.asistencia == 1 ) || ( opHuella == 2 && !teacher.asistencia ) || opHuella == 3"
                  >
                      <v-icon left v-if="teacher.asistencia == 1">mdi-circle-medium</v-icon>
                      <v-icon left v-if="teacher.reemplazo == 1">mdi-skull</v-icon>
                      {{ teacher.nombre_completo }}
                      <v-icon class="ml-2" @click="eliminarTeacher( teacher )">mdi-close</v-icon>
                  </v-chip>
                </span>
                <v-chip v-if="!item.teacherslider.length" small color="red" dark @click="agregarTeacher( item )">
                  Agregar
                </v-chip>
              </template>

              <!-- Validación de encargadas -->
              <template v-slot:item.encargadasOP="{ item }">
                <span
                  v-for="( encargada, i ) in item.encargadasOP"
                  :key="i"
                >
                  <v-chip
                    small
                    :color="encargada.asistencia == 1 && encargada.validada ? 'green' : encargada.asistencia == 1 ? 'yellow' : 'red' "
                    :dark="encargada.asistencia == 1 && encargada.validada ? true : encargada.asistencia == 1 ? false : true "
                    @click="asignarEncargada(
                      encargada,
                      1,
                      item.idplantel,
                      encargada.escuela,
                      encargada.idreemplazos_coordinacion,
                      null,
                      item)
                    "
                    v-if="( opHuella == 1 && encargada.asistencia == 1 ) || ( opHuella == 2 && !encargada.asistencia ) || opHuella == 3"
                  >
                    <v-icon left v-if="encargada.asistencia == 1">mdi-circle-medium</v-icon>
                    <v-icon left v-if="encargada.reemplazo == 1">mdi-skull</v-icon>
                    {{ encargada.nombre_usuario }}
                  </v-chip>
                </span>

                <v-chip v-if="item.encargadasCant == 0" small color="white">
                  N/A
                </v-chip>

                <v-chip small
                  @click="asignarEncargada(
                    null,
                    1,
                    item.idplantel,
                    0,
                    null,
                    null,
                    item)">
                    +
                </v-chip>
              </template>

              <!-- Recepcionista -->
              <template v-slot:item.recepcionistaMatOP="{ item }">
                <span
                  v-for="( recepcionista, i ) in item.recepcionistaMatOP"
                  :key="i"
                >
                  <v-chip small
                    :color="recepcionista.asistencia == 1 && recepcionista.validada ? 'green' : recepcionista.asistencia == 1 ? 'yellow' : 'red' "
                    :dark="recepcionista.asistencia == 1 && recepcionista.validada ? true : recepcionista.asistencia == 1 ? false : true "
                    @click="usuario_a_reasignar = recepcionista, tipo = 2, dialogReasignar = true, id_plantelSeccion = item.idplantel, escuelaOP = recepcionista.escuela, idreemplazos_coordinacion =  recepcionista.idreemplazos_coordinacion, marcarFilaCoordinacion(item)"

                    v-if="( opHuella == 1 && recepcionista.asistencia == 1 ) || ( opHuella == 2 && !recepcionista.asistencia ) || opHuella == 3"
                  >
                    <v-icon left v-if="recepcionista.asistencia == 1">mdi-circle-medium</v-icon>
                    <v-icon left v-if="recepcionista.reemplazo == 1">mdi-skull</v-icon>
                    {{ recepcionista.nombre_usuario }}
                  </v-chip>
                </span>

                <v-chip small
                  @click="asignarEncargada(null, 2, item.idplantel, 0, null, item.recepcionistaVesOP, item)"
                >
                  +
                </v-chip>
              </template>

              <!-- Recepcionista -->
              <template v-slot:item.recepcionistaVesOP="{ item }">
                <span
                  v-for="( recepcionista, i ) in item.recepcionistaVesOP"
                  :key="i"
                >
                  <v-chip small
                    :color="recepcionista.asistencia == 1 && recepcionista.validada ? 'green' : recepcionista.asistencia == 1 ? 'yellow' : 'red' "
                    :dark="recepcionista.asistencia == 1 && recepcionista.validada ? true : recepcionista.asistencia == 1 ? false : true "
                    @click="usuario_a_reasignar = recepcionista, tipo = 3, dialogReasignar = true, id_plantelSeccion = item.idplantel, escuelaOP = recepcionista.escuela, idreemplazos_coordinacion =  recepcionista.idreemplazos_coordinacion, marcarFilaCoordinacion(item)"

                    v-if="( opHuella == 1 && recepcionista.asistencia == 1 ) || ( opHuella == 2 && !recepcionista.asistencia ) || opHuella == 3"
                  >
                    <v-icon left v-if="recepcionista.asistencia == 1">mdi-circle-medium</v-icon>
                    <v-icon left v-if="recepcionista.reemplazo == 1">mdi-skull</v-icon>
                    {{ recepcionista.nombre_usuario }}
                  </v-chip>
                </span>

                <v-chip small
                  @click="asignarEncargada(null, 3, item.idplantel, 0, null, item.recepcionistaVesOP, item)"
                >
                  +
                </v-chip>
              </template>

              <!-- Comentarios -->
              <template v-slot:item.comentarios="{ item }">
                <span
                  v-if="item.comentarios"
                  @dblclick="abrirEditarComentario(item)"
                  class="text-caption pointer"
                  style="cursor: pointer;"
                >
                  {{ item.comentarios }}
                </span>
                <v-btn
                  v-else-if="!item.esExtension"
                  @click="abrirEditarComentario(item)"
                  x-small
                  color="primary"
                  outlined
                >
                  <v-icon left x-small>mdi-comment-plus</v-icon>
                  Agregar comentario
                </v-btn>
              </template>

              <!-- <template v-slot:item.recepcionistaVesOP="{ item }">
                <v-chip
                  small
                  v-if="item.recepcionistaVesOP.length && ( ( opHuella == 1 && item.recepcionistaVesOP[0].asistencia == 1 ) || ( opHuella == 2 && !item.recepcionistaVesOP[0].asistencia ) || opHuella == 3 )"
                  :color="item.recepcionistaVesOP[0].asistencia == 1 && item.recepcionistaVesOP[0].asistencia.validada ? 'green' : item.recepcionistaVesOP[0].asistencia == 1 ? 'yellow' : 'red' "
                  :dark="item.recepcionistaVesOP[0].asistencia == 1 && item.recepcionistaVesOP[0].asistencia.validada ? true : item.recepcionistaVesOP[0].asistencia == 1 ? false : true "
                  @click="
                  asignarEncargada(
                    item.recepcionistaVesOP[0],
                    2,
                    item.idplantel,
                    item.recepcionistaVesOP[0].escuela,
                    item.recepcionistaVesOP[0].idreemplazos_coordinacion,
                    item.recepcionistaVesOP
                  )
                  "
                >
                  <v-icon left v-if="item.recepcionistaVesOP[0].asistencia == 1">mdi-circle-medium</v-icon>
                  <v-icon left v-if="item.recepcionistaVesOP[0].reemplazo == 1">mdi-skull</v-icon>
                  {{ item.recepcionistaVesOP[0].nombre_usuario }}
                </v-chip>
                <v-chip v-else-if="item.recepcionistaVesCant == 0" small color="white">
                  NA
                </v-chip>
                <v-chip small
                  @click="asignarEncargada(null, 3, item.idplantel, 0, null, item.recepcionistaVesOP)"
                >
                  +
                </v-chip>


                <v-chip
                  small
                  v-if="item.recepcionistaVesOP.length == 2 && ( ( opHuella == 1 && item.recepcionistaVesOP[1].asistencia == 1 ) || ( opHuella == 2 && !item.recepcionistaVesOP[1].asistencia ) || opHuella == 3 )"
                  :color="item.recepcionistaVesOP[1].asistencia == 1 && item.recepcionistaVesOP[1].asistencia.validado ? 'green' : item.recepcionistaVesOP[1].asistencia == 1 ? 'yellow' : 'red' "
                  :dark="item.recepcionistaVesOP[1].asistencia == 1 && item.recepcionistaVesOP[1].asistencia.validado ? true : item.recepcionistaVesOP[1].asistencia == 1 ? false : true "
                  @click="asignarEncargada(
                    item.recepcionistaVesOP[1],
                    2,
                    item.idplantel,
                    item.recepcionistaVesOP[1].escuela,
                    item.recepcionistaVesOP[1].idreemplazos_coordinacion,
                    item.recepcionistaVesOP)"
                >
                  <v-icon left v-if="item.recepcionistaVesOP[1].asistencia == 1">mdi-circle-medium</v-icon>
                  <v-icon left v-if="item.recepcionistaVesOP[1].reemplazo == 1">mdi-skull</v-icon>
                  {{ item.recepcionistaVesOP[1].nombre_usuario }}
                </v-chip>
              </template> -->

  				    <template v-slot:no-data>
  				      <v-btn
  				        color="primary"
  				        @click="initialize"
  				        small
  				      >
  				        Actualizar
  				      </v-btn>
  				    </template>
  				  </v-data-table>

          </v-card-text>

				</v-card>
		  </v-col>
    </v-row>

    <v-dialog v-model="dialogTelefonos"max-width="900">
      <v-card>
        <v-card-title primary-title >
          <v-icon left>mdi-account</v-icon> Validación de Entrada
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text >

          <div v-if="encargadas_telefonos.length">

            <div><b>Personal:</b> {{ encargadas_telefonos[0].nombre_completo }}</div>
            <div><b>Hora Entrada:</b> {{ encargadas_telefonos[0].hora_registro }}</div>
            <div><b>Estatus:</b> {{ encargadas_telefonos[0].asistencia ? 'Con Registro' : 'Sin Registro' }}</div>
            <div><b>Validado:</b> {{ encargadas_telefonos[0].validada ? 'Con Validación' : 'Sin validación' }}</div>
            <div v-if="encargadas_telefonos[0].validada"><b>Validó:</b> {{ encargadas_telefonos[0].validada.nombre_completo }}</div>


            <v-alert
              dense
              outlined
              type="info"
            >
              Yo <b>{{ getdatosUsuarioERPERP.nombre_completo }}</b>, confirmo que: <b>{{ encargadas_telefonos[0].nombre_completo }}</b> registró su entrada el día <b>{{ fecha }}</b> a las <b>{{ encargadas_telefonos[0].hora_registro }}</b> y que no requiere ningún cambio de horario.
            </v-alert>

            <v-btn
              small
              tile
              color="success"
              class="mr-2"
              @click="validaEncargada( encargadas_telefonos[0] )"
              v-if="encargadas_telefonos[0].asistencia && !encargadas_telefonos[0].validada "
            >
              Validar Entrada <v-icon small right>mdi-check</v-icon>
            </v-btn>

            <v-btn
              small
              tile
              color="orange"
              dark
              @click="openModalCambios.estatus = true"
              v-if="encargadas_telefonos[0].asistencia && !encargadas_telefonos[0].validada"
            >
              Solicitar cambio de horario <v-icon small right>mdi-file-document</v-icon>
            </v-btn>

          </div>

          <br/>
          <br/>

          <v-data-table
            :headers="headersTelefonos"
            :items="encargadas_telefonos"
            class="elevation-0"
            dense
          >
          <template v-slot:item.nombre_completo="{ item }">
            <v-row align="center">
              <p class="ma-0 me-5">{{ item.nombre_completo }}</p>
              <v-checkbox
              v-model="reemplazoAux"
              :label="`Reemplazo`"
              v-if="getdatosUsuarioERPERP.idpuesto != 31"
              ></v-checkbox>
            </v-row>
          </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="dialogTelefonos = false"
            top
            absolute
            icon
            right
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn color="primary" v-if="getdatosUsuarioERPERP.idpuesto != 31"  dark @click="(encargadas_telefonos[0].reemplazo = reemplazoAux), actualizarPuesto(encargadas_telefonos)">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCoordi"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Selecciona una coordinadora para este plantel
        </v-card-title>
        <v-card-text v-if="plantelSeleccionado" class="black--text">
          <b>Plantel:</b> {{ plantelSeleccionado.plantel }}

          <br/>
          <v-autocomplete
            filled
            dense
            clearable
            v-model="coordinadora"
            :items="coordinadoras"
            label="Selecciona la coordinadora"
            item-text="nombre_completo"
            item-value="id_usuario"
            class="mt-4"
            hide-details
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            tile
            @click="dialogCoordi = false"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            small
            tile
            @click="saveCoordi( )"
          >
            Guardar
            <v-icon right small>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- AGREGAR RESPONSABLE DE CLASES -->
    <v-dialog
      v-model="dialogResponsableClases"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Selecciona la responsable de clases para este plantel
        </v-card-title>
        <v-card-text v-if="plantelSeleccionado" class="black--text">
          <b>Plantel:</b> {{ plantelSeleccionado.plantel }}

          <br/>
          <v-autocomplete
            filled
            dense
            clearable
            v-model="responsableClase"
            :items="responsablesClases"
            label="Selecciona la responsable de clases"
            item-text="nombre_completo"
            item-value="id_usuario"
            class="mt-4"
            hide-details
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            tile
            @click="dialogResponsableClases = false"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            small
            tile
            @click="saveResponsableClases( )"
          >
            Guardar
            <v-icon right small>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AGREGAR VENDEDORA -->
    <v-dialog
      v-model="dialogVendedora"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Selecciona una coordinadora para este plantel
        </v-card-title>
        <v-card-text v-if="plantelSeleccionado" class="black--text">
          <b>Plantel:</b> {{ plantelSeleccionado.plantel }}

          <br/>
          <v-autocomplete
            filled
            dense
            clearable
            v-model="vendedora"
            :items="vendedoras"
            label="Selecciona la vendedora"
            item-text="nombre_completo"
            item-value="id_usuario"
            class="mt-4"
            hide-details
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            tile
            @click="dialogVendedora = false"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            small
            tile
            @click="saveVendedora( )"
          >
            Guardar
            <v-icon right small>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Mostrar teachers -->
    <v-dialog
      v-model="dialogAsistenciasTeacher"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Lista de teacher y asistencia
        </v-card-title>
        <v-card-text v-if="plantelSeleccionado" class="black--text">
          <b>Plantel:</b> {{ plantelSeleccionado.plantel }}

          <br/>
          <v-data-table
            :headers="headersTeachers"
            :items="teacherAsistencia"
            class="elevation-0"
            dense
          >

            <template v-slot:item.asistencia="{ item }">
              <v-chip :color="item[`asistencia_${opTeacher}`] ? 'green' : 'red' " dark small> {{ item[`asistencia_${opTeacher}`] ? 'Con asistencia' : 'No ha llegado' }} </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            tile
            @click="dialogAsistenciasTeacher = false"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="todosTeachersConEntradaCorrecta"
            color="green"
            dark
            small
            tile
            @click="saveConfirmacionTeacherCompletos( )"
          >
            <v-icon left small>mdi-check</v-icon>
            Aceptar
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- AGREGAR TEACHER -->
    <v-dialog
      v-model="dialogTeachers"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Selecciona un Coordinador Académico para este plantel
        </v-card-title>
        <v-card-text v-if="plantelSeleccionado" class="black--text">
          <b>Plantel:</b> {{ plantelSeleccionado.plantel }}

          <br/>
          <v-autocomplete
            filled
            dense
            clearable
            v-model="teacher"
            :items="teachersLider"
            label="Selecciona el Coordinador Académico"
            item-text="nombre_completo"
            item-value="id_usuario"
            class="mt-4"
            hide-details
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            tile
            @click="dialogTeachers = false"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            small
            tile
            @click="saveTeacher( )"
          >
            Guardar
            <v-icon right small>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AGREGAR TEACHER -->
    <v-dialog
      v-model="dialogValidarSucursal"
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Validación de Apertura
        </v-card-title>
        <v-card-text class="black--text text-center">
          ¿Estás de acuerdo con que la sucursal se encuentra abierta en este momento?

          <br/>
          <br/>

          <span v-if="plantelSeleccionado">
            <b>Plantel:</b> {{ plantelSeleccionado.plantel }}
          </span>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            small
            icon
            absolute
            top
            right
            @click="dialogValidarSucursal = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            block
            @click="saveConfirmacion( )"
          >
            Aceptar apertura de sucursal
            <v-icon right small>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AGREGAR TEACHER -->
    <v-dialog
      v-model="dialgoApertura"
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Apertura validada
        </v-card-title>
        <v-card-text class="black--text" v-if="plantelSeleccionado">
          <b>Coordinadora:</b> {{ plantelSeleccionado.nombre_completo }}
          <br/>
          <b>Plantel:</b> {{ plantelSeleccionado.plantel }}
          <br/>
          <b>Fecha confirmaicón:</b> {{ plantelSeleccionado.fecha_creacion }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            small
            icon
            absolute
            top
            right
            @click="dialgoApertura = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            block
            @click="saveConfirmacion( )"
          >
            Aceptar apertura de sucursal
            <v-icon right small>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Validar el corte -->
    <v-dialog
      v-model="validarCorte"
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title class="text-subtitle-1">
        </v-card-title>
        <v-card-text class="black--text text-h5 text-center" v-if="plantelSeleccionado">
          <br/>
          ¿Estás segura de que el corte de {{ plantelSeleccionado.plantel }} ya se ingresó a la caja?
          <br/>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            icon
            top
            right
            absolute
            @click="validarCorte = false"
          ><v-icon>mdi-close</v-icon></v-btn>

          <v-btn
            color="black"
            class="white--text"
            @click="validarCorte = false"
          >No, cancelar</v-btn>

          <v-spacer></v-spacer>

          <v-btn
            color="#f073f0"
            @click="validarCorteSuccess( )"
          >Sí, super segura!</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para reasignar vendedoras o recepcionistas -->
    <v-dialog
      v-model="dialogReasignar"
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>Reemplazar el personal</v-card-title>
        <v-card-text  class="black--text">
          Actual: {{ usuario_a_reasignar ? usuario_a_reasignar.nombre_usuario : 'SIN USUARIO' }} <br/>
          Teléfono: {{ usuario_a_reasignar ? usuario_a_reasignar.telefono1 : 'SIN TELEFONO' }} <br/>
          <br/>

          <label>Usuario reemplaza</label>
          <v-autocomplete
            class="mt-2"
            filled
            dense
            clearable
            v-model="usuarioReemplaza"
            :items="encargadasFilter"
            label="Seleeciona un usuario"
            persistent-hint
            prepend-inner-icon="mdi-clipboard-outline"
            return-object
            item-text="nombre_completo"
            item-value="id"
            v-if="tipo == 1"
          >
          </v-autocomplete>

          <v-autocomplete
            class="mt-2"
            filled
            dense
            clearable
            v-model="usuarioReemplaza"
            :items="recepcionesFilter"
            label="Seleeciona un usuario"
            persistent-hint
            prepend-inner-icon="mdi-clipboard-outline"
            return-object
            item-text="nombre_completo"
            item-value="id"
            v-if="[2,3].includes( tipo )"
          >
          </v-autocomplete>


        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="usuario_a_reasignar && usuario_a_reasignar.idreemplazos_coordinacion"
            @click="eliminarReemplazo( )"
            color="black"
            dark
            small
          >
            Eliminar reemplazo
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            small
            @click="saveReemplazo( )"
          >
            Guardar <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Solicitar el cambio de horario -->
    <ModalCambioHorario
      :openModalCambios="openModalCambios"
      v-if="openModalCambios.estatus"
    />

    <!-- Ver el dialogo de vacantes -->
    <dialogVacantes
      v-if="dialogVacantes.estatus"
      :dialogVacantes="dialogVacantes"
      :ultimoCambio="ultimoCambio"
      :colaboradoresTotales="colaboradoresTotales"
    />

    <!-- Ver el dialogo de vacantes -->
    <dialogVacante
      v-if="dialogVacante.estatus"
      :dialogVacante="dialogVacante"
      :dataVancante="dataVancante"
      @addSolicitud="addSolicitud"
    />

    <!-- Ver el dialogo de teachers no rolados -->
    <dialogRolados
    	v-if="dialogRolados.estatus"
    	:dialogRolados="dialogRolados"
    	:gruposRoles="gruposRoles"
    	:teachers="teachers"
    />

    <!-- Dialog Editar Comentarios -->
    <v-dialog
      v-model="dialogEditarComentario"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Editar Comentarios
        </v-card-title>
        <v-card-text>
          <div v-if="plantelSeleccionadoComentario" class="mb-3">
            <b>Plantel:</b> {{ plantelSeleccionadoComentario.plantel }}
          </div>
          <v-textarea
            v-model="comentarioEditado"
            label="Comentarios"
            filled
            dense
            rows="4"
            auto-grow
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            tile
            @click="dialogEditarComentario = false"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            small
            tile
            @click="guardarComentario"
          >
            Guardar
            <v-icon right small>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

	  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
  import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'
  import funcionesExcel  from '@/mixins/funcionesExcel'
  import dialogRolados   from '@/components/roles/dialogRolados.vue';

  import ModalCambioHorario from '@/components/nomina/ModalCambioHorario.vue'
  import dialogVacantes     from '@/components/visualizador/dialogVacantes.vue'
  import dialogVacante      from '@/components/visualizador/dialogVacante.vue'

  export default {

  	components:{
      Alerta,
      carga,
      ModalCambioHorario,
      dialogVacantes,
      dialogRolados
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      teachers:[],
      gruposRoles: [],


      reemplazoAux: 0,

      // Accesos para esther, luis padilla, david, yo

      accesos: [ 568, 2556, 1, 334, 2767 ],

      dialog: false,
      dialogDelete: false,
      dialogVacantes:{
        estatus: false
      },
      dialogTelefonos: false,
      encargadas_telefonos : [],
      colaboradoresTotales : [],
      puestosTotales : [],
      ultimoCambio : '',
      coordinadoras: [],
      coordinadora: null,
      responsablesClases: [],
      responsableClase: null,
      dialogResponsableClases: false,
      vendedora: null,
      vendedoras:[],
      headers: [
        { text: 'Plantel',                     value: 'plantel',           },
        { text: 'Apertura',                    value: 'apertura',          },
        { text: 'Coordinador de zona',         value: 'coordi'             },
        // { text: 'Coord Académico',             value: 'teacherslider'      },
        // { text: 'Vendedora',                   value: 'vendedoras_2'       },
        // { text: 'Encargada',                   value: 'encargadas',        },
        // { text: 'Recepcionista Matutina',      value: 'recepcionistaMat',  },
        // { text: 'Recepcionista Vespertina',    value: 'recepcionistaVes',  },

        { text: 'Encargada',                   value: 'encargadasOP',        },
        { text: 'Recepcionista Matutina',      value: 'recepcionistaMatOP',  },
        { text: 'Recepcionista Vespertina',    value: 'recepcionistaVesOP',  },
        { text: 'Responsable de clases',       value: 'responsableClases',   },
        { text: 'Teachers'                ,    value: 'validaTeachers',    },
        { text: 'Corte',                       value: 'corteCaja' ,        },
        { text: 'Comentarios',                       value: 'comentarios' ,        },
      ],

      headersTelefonos: [
        { text: 'Nombre'                    , value: 'nombre_completo' },
        { text: 'Telefono1'                 , value: 'telefono1' },
        { text: 'Telefono2'                 , value: 'telefono2' },
      ],
      empleados: [],
      search:'',

      payload:{
        totalesINBI:0,
        totalesFAST:0,
        totalesVacantesCubrirINBI:0,
        totalesVacantesCubrirFAST:0,
        totalesOcupamosINBI:0,
        totalesOcupamosFAST:0,
        totalesReemplazosINBI:0,
        totalesReemplazosFAST:0,
        totalesVacantesINBI:0,
        totalesVacantesFAST:0,
      },

      dataVancante: null,

      dialogVacante:{
        estatus: false
      },

      plantelSeleccionado: null,
      dialogCoordi: false,
      dialogVendedora: false,
      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      dialogTeachers: false,
      teacher: null,
      teachersLider:[],
      dialogValidarSucursal: false,
      dialgoApertura: false,
      escuela: 3,
      validada: 3,
      opHuella: 3,
      opHuellaTeacher:3,
      openModalCambios:{
        estatus: false,
      },

      validarCorte: false,

      opTurno: 1,

      dialogAsistenciasTeacher: false,
      teacherAsistencia: [],
      headersTeachers:[
        { text: 'Nombre'        , value: 'nombre'      },
        { text: 'Asistencia'    , value: 'asistencia'  },
        { text: 'Hora inicio'   , value: 'hora_inicio' }
      ],
      opTeacher:0,
      usuario_a_reasignar: null,
      tipo: 0,
      dialogReasignar: false,
      encargadas: [],
      recepciones : [],
      usuarioReemplaza: null,
      id_plantelSeccion: null,
      escuelaOP: 0,
      idreemplazos_coordinacion: 0,
      personal:[],
      noRepetidos: [],
      accesos: [568,626,7,1312,161,1248,1196,1489,1312,28,1778, 2221, 2781],
      dialogRolados: {
				estatus: false
			},
      dialogEditarComentario: false,
      filaCoordinacion: null,
      plantelSeleccionadoComentario: null,
      comentarioEditado: '',
    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    async created () {
      await this.initialize()
      await this.getTeachersActivos()
    },

    computed: {
      ...mapGetters("login", ["getdatosUsuarioERPERP", "getLogeado"]),

      todosTeachersConEntradaCorrecta(){
        if ( !this.teacherAsistencia || !this.teacherAsistencia.length ) return false
        const key = 'asistencia_' + this.opTeacher
        return this.teacherAsistencia.every( t => t[key] )
      },

      filterEmpleados( ){

        let data = this.empleados

        if( this.escuela != 3 ){

          if( this.escuela == 1 ){
            data = data.filter( el => !(el.plantel_madre || el.plantel || '').match('FAST') )
          }else{
            data = data.filter( el => (el.plantel_madre || el.plantel || '').match('FAST') )
          }

        }

        if( this.validada != 3 ){

          if( this.validada == 1 ){
            data = data.filter( el => el.abrio && el.confirmado )
          }else if( this.validada == 2 ){
            data = data.filter( el => el.abrio && !el.confirmado )
          }else{
            data = data.filter( el => !el.abrio && !el.confirmado )
          }

        }

        return data
      },

      plantelesKpi( ){
        return this.filterEmpleados.filter( el => !el.esExtension )
      },

      encargadasFilter( ){

        return this.personal

        data = data.filter( el => el.escuela == this.escuelaOP )

        return data
      },

      recepcionesFilter( ){

        return this.personal.filter(p => !this.noRepetidos.includes( p.id) )

        data = data.filter( el => el.escuela == this.escuelaOP )

        return data
      },


    },

    methods: {
      initialize () {
        this.empleados = []
        this.cargar = true

        this.colaboradoresTotales = Object.assign({}, this.payload )
        this.$http.get('puestos.plantel').then(response=>{
          this.puestosTotales = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { })

        this.$http.get('trabajador.ultimocambio').then(response=>{
          this.ultimoCambio = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { })


        const payload = {
          dia: this.fecha,
          turno: this.opTurno
        }

        return this.$http.post('asistencias.visuales', payload ).then(response=>{

          // TODO
          this.coordinadoras  = response.data.personal.filter( el => el.idpuesto == 73 || el.idpuesto == 88)
          this.vendedoras     = response.data.personal.filter( el => el.idpuesto != 82)
          this.teachersLider  = response.data.personal.filter( el => el.idpuesto == 82 )
          this.responsablesClases = response.data.personal
          this.encargadas     = response.data.personal.filter( el => el.idpuesto == 18 || el.idpuesto == 19 ) // encargadas
          this.recepciones    = response.data.personal.filter( el => el.idpuesto == 19 ) // recepcionistas
        	this.empleados      = response.data.plantelesActivos
          this.opTeacher      = response.data.opTeacher
          this.personal       = response.data.personal

          this.personal.unshift( {
            id: -1,
            nombre_completo: 'Descanso'
          })

          this.encargadas.unshift( {
            id: -1,
            nombre_completo: 'Descanso'
          })

          this.recepciones.unshift( {
            id: -1,
            nombre_completo: 'Descanso'
          })

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      actualizarPuesto(item){
        this.cargar = true;
         this.$http.put('trabajador.reemplazo/'+item[0].reemplazo +'/' +item[0].id_trabajador+'/'+this.getdatosUsuarioERPERP.iderp).then(response=>{
          this.initialize()
          this.validarSuccess ( response.data )
         }).catch( error =>{
           this.validarError( error.response.data.message )
         }).finally( () => { this.cargar = false })
      },

      validarSuccess( mensaje ){
        this.cargar = false
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true
        this.parametros.color        = 'success'
        this.respuestaAlerta         = true
      },

      marcarFilaCoordinacion (item) {
        this.filaCoordinacion = item
      },

      payloadPersonalExtension (tipo, persona) {
        var fila = this.plantelSeleccionado || this.filaCoordinacion
        var existente = null
        if (fila) {
          if (Number(tipo) === 4 && fila.coordi && fila.coordi.length) existente = fila.coordi[0]
          else if (Number(tipo) === 5 && fila.responsableClases && fila.responsableClases.length) existente = fila.responsableClases[0]
        }
        return {
          idplantel_extension: (this.plantelSeleccionado && this.plantelSeleccionado.idplantel_extension) || (this.filaCoordinacion && this.filaCoordinacion.idplantel_extension),
          idplantel_extension_personal: (this.usuario_a_reasignar && (this.usuario_a_reasignar.idplantel_extension_personal || this.usuario_a_reasignar.idreemplazos_coordinacion))
            || (existente && existente.idplantel_extension_personal)
            || null,
          tipo,
          id_usuario: persona.id_usuario || persona.iderp || null,
          id_trabajador: persona.id || null,
          nombre_usuario: persona.nombre_completo || persona.nombre_usuario || '',
          usuario_registro: this.getdatosUsuarioERPERP.iderp
        }
      },

      agregarCoordi( item ){

        this.plantelSeleccionado = item
        this.filaCoordinacion = item
        this.dialogCoordi = true
      },

      agregarResponsableClases( item ){
        this.plantelSeleccionado = item
        this.filaCoordinacion = item
        this.responsableClase = null
        this.dialogResponsableClases = true
      },

      eliminarResponsableClases( item, fila ){
        this.cargar = true
        if (fila && fila.esExtension) {
          this.$http.post('plantel.extension.personal.delete', {
            idplantel_extension_personal: item.idplantel_extension_personal
          }).then(response => {
            this.initialize( )
            this.dialogResponsableClases = false
            this.validarSuccess( response.data.message )
          }).catch( error => {
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
          return
        }
        const payload = {
          idresponsable_clases: item.idresponsable_clases
        }
        this.$http.post('plantel.responsable_clases.delete', payload ).then(response => {
          this.initialize( )
          this.dialogResponsableClases = false
          this.validarSuccess( response.data.message )
        }).catch( error => {
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      saveResponsableClases( ){
        this.cargar = true
        if (this.plantelSeleccionado && this.plantelSeleccionado.esExtension) {
          const persona = this.personal.find(el => el.id_usuario == this.responsableClase || el.iderp == this.responsableClase) || { id_usuario: this.responsableClase }
          this.$http.post('plantel.extension.personal', this.payloadPersonalExtension(5, persona)).then(response => {
            this.initialize( )
            this.dialogResponsableClases = false
            this.validarSuccess( response.data.message )
          }).catch( error => {
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
          return
        }
        const payload = {
          id_usuario: this.responsableClase,
          id_plantel: this.plantelSeleccionado.idplantel,
          dia: this.fecha,
          modifico: this.getdatosUsuarioERPERP.iderp
        }
        this.$http.post('plantel.responsable_clases', payload ).then(response => {
          this.initialize( )
          this.dialogResponsableClases = false
          this.validarSuccess( response.data.message )
        }).catch( error => {
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      agregarTeacher( item ){

        this.plantelSeleccionado = item
        this.dialogTeachers = true
      },

      eliminarVendedora( item ){
        this.cargar = true;
        this.dialogTelefonos = false

        this.$http.post('plantel.vendedora.delete', item ).then(response=>{
          this.initialize( )
          this.dialogVendedora = false
          this.dialogCoordi    = false
          this.dialogTeachers  = false
          this.dialogTelefonos = false
          this.validarSuccess ( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      agregarVendedora( item ){

        this.plantelSeleccionado = item
        this.dialogVendedora = true
      },

      eliminarCoordi( item, fila ){

        this.cargar = true;
        this.dialogTelefonos = false

        if ((fila && fila.esExtension) || item.esExtension || item.idplantel_extension_personal) {
          this.$http.post('plantel.extension.personal.delete', {
            idplantel_extension_personal: item.idplantel_extension_personal
          }).then(response=>{
            this.initialize( )
            this.dialogCoordi = false
            this.dialogTelefonos = false
            this.validarSuccess ( response.data.message )
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
          return
        }

        this.$http.post('plantel.coordinadora.delete', item ).then(response=>{
          this.initialize( )
          this.dialogCoordi = false
          this.dialogTelefonos = false
          this.validarSuccess ( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      saveCoordi( ){
        this.cargar = true;

        if (this.plantelSeleccionado && this.plantelSeleccionado.esExtension) {
          const persona = this.coordinadoras.find(el => el.id_usuario == this.coordinadora) || this.personal.find(el => el.id_usuario == this.coordinadora) || { id_usuario: this.coordinadora }
          this.$http.post('plantel.extension.personal', this.payloadPersonalExtension(4, persona)).then(response=>{
            this.initialize( )
            this.dialogCoordi = false
            this.validarSuccess ( response.data.message )
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
          return
        }

        const payload = {
          id_usuario: this.coordinadora,
          id_plantel: this.plantelSeleccionado.idplantel,
          modifico:   this.getdatosUsuarioERPERP.iderp
        }

        this.$http.post('plantel.coordinadora', payload ).then(response=>{
          this.initialize( )
          this.dialogCoordi = false
          this.validarSuccess ( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      saveVendedora( ){
        this.cargar = true;

        const payload = {
          id_usuario: this.vendedora,
          id_plantel: this.plantelSeleccionado.idplantel,
          dia       : this.fecha,
          modifico  : this.getdatosUsuarioERPERP.iderp
        }

        this.$http.post('plantel.vendedora', payload ).then(response=>{
          this.initialize( )
          this.dialogVendedora = false
          this.dialogCoordi = false
          this.validarSuccess ( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      saveTeacher( ){
        this.cargar = true;

        const payload = {
          id_usuario: this.teacher,
          id_plantel: this.plantelSeleccionado.idplantel,
          modifico  : this.getdatosUsuarioERPERP.iderp
        }

        this.$http.post('plantel.teachers', payload ).then(response=>{
          this.initialize( )
          this.dialogVendedora = false
          this.dialogCoordi    = false
          this.dialogTeachers  = false
          this.dialogTelefonos = false
          this.validarSuccess ( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      saveConfirmacion( ){
        this.cargar = true;

        const payload = {
          id_coordinadora: this.getdatosUsuarioERPERP.iderp,
          id_plantel     : this.plantelSeleccionado.idplantel,
          fecha          : this.fecha,
        }

        this.$http.post('validar.apertura', payload ).then(response=>{
          this.initialize( )
          this.dialogVendedora = false
          this.dialogCoordi    = false
          this.dialogTeachers  = false
          this.dialogTelefonos = false
          this.dialogValidarSucursal = false
          this.validarSuccess ( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      validaEncargada( item ){

        let ruta = item.idpuesto == 19 ? 'plantel.recepcion' : 'plantel.encargada'

        this.cargar = true;

        const payload = {
          id_usuario: item.id_usuario,
          id_plantel: this.plantelSeleccionado.idplantel,
          dia       : this.fecha,
          modifico  : this.getdatosUsuarioERPERP.iderp
        }

        this.$http.post(ruta, payload ).then(response=>{
          this.initialize( )
          this.dialogVendedora = false
          this.dialogCoordi    = false
          this.dialogTelefonos = false
          this.validarSuccess ( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      eliminarTeacher( item ){

        this.cargar = true;
        this.dialogTelefonos = false

        this.$http.post('plantel.teachers.delete', item ).then(response=>{
          this.initialize( )
          this.dialogVendedora = false
          this.dialogCoordi    = false
          this.dialogTeachers  = false
          this.dialogTelefonos = false
          this.validarSuccess ( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      validarCorteSuccess( ){

        this.cargar = true;

        const payload = {
          id_plantel: this.plantelSeleccionado.idplantel,
          fecha     : this.fecha,
          modifico  : this.getdatosUsuarioERPERP.iderp
        }

        this.$http.post('validar.corte.entregado', payload ).then(response=>{

          this.initialize( )
          this.dialogVendedora = false
          this.dialogCoordi    = false
          this.dialogTelefonos = false
          this.validarCorte    = false
          this.validarSuccess ( response.data.message )

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      saveConfirmacionTeacherCompletos( ){

        this.cargar = true;

        const responsables = this.plantelSeleccionado && ( this.plantelSeleccionado.responsableClases || this.plantelSeleccionado.responsable_clases || [] )
        const idResponsable = responsables.length ? ( responsables[0].id_usuario_oficial || responsables[0].id_usuario ) : null

        const payload = {
          fecha          : this.fecha,
          turno          : this.opTurno,
          id_plantel     : this.plantelSeleccionado.idplantel,
          modifico       : this.getdatosUsuarioERPERP.iderp,
          id_responsable : idResponsable
        }

        this.$http.post('validar.teachers.completos', payload ).then(response=>{

          this.initialize( )
          this.dialogVendedora = false
          this.dialogCoordi    = false
          this.dialogTelefonos = false
          this.validarCorte    = false
          this.dialogTeachers  = false
          this.dialogAsistenciasTeacher = false
          this.validarSuccess ( response.data.message )

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {

      	this.alumno = item

       	if( item.escuela == 2 )
       		this.urlDirecta = this.urlFast + item.nombre_video
       	else
       		this.urlDirecta = this.urlInbi + item.nombre_video

        this.dialog = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      dialogAddVacante( item, puesto ){
        this.dataVancante = {
          idplantel: item.idplantel,
          plantel: item.plantel,
          puesto
        }

        let payload = {
          idplantel: this.dataVancante.idplantel,
          plantel  : this.dataVancante.plantel,
          puesto   : this.dataVancante.puesto,
          solicito: this.getdatosUsuarioERPERP.iderp
        }

        this.cargar = true;
        this.$http.post('vacante.get', payload ).then(response=>{

          if( response.data ){
            this.dataVancante['dias']  = response.data.dias || null
            this.dataVancante['fecha'] = response.data.fecha_creacion || null
            this.dataVancante['id']    = response.data.idvacante_rh || null
          }

          this.dialogVacante.estatus = true

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

        // Ver si hay una solicitud
      },

      addSolicitud( ){
        let payload = {
          idplantel: this.dataVancante.idplantel,
          plantel: this.dataVancante.plantel,
          puesto : this.dataVancante.puesto,
          solicito: this.getdatosUsuarioERPERP.iderp
        }

        this.cargar = true;
        this.$http.post('vacante.add', payload ).then(response=>{
          this.dialogVacante.estatus = false
          this.initialize()
          this.validarSuccess ( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      async saveReemplazo() {

        // Evita doble submit
        if (this.cargar) return;

        // Validaciones mínimas
        if (!this.usuarioReemplaza) {
          return this.validarErrorDirecto("Favor de seleccionar un reemplazo");
        }

        if (this.filaCoordinacion && this.filaCoordinacion.esExtension) {
          this.cargar = true;
          try {
            await this.$http.post('plantel.extension.personal', {
              idplantel_extension: this.filaCoordinacion.idplantel_extension,
              idplantel_extension_personal: this.usuario_a_reasignar && (
                this.usuario_a_reasignar.idplantel_extension_personal || this.usuario_a_reasignar.idreemplazos_coordinacion
              ),
              tipo: this.tipo,
              id_usuario: this.usuarioReemplaza.id_usuario || this.usuarioReemplaza.iderp,
              id_trabajador: this.usuarioReemplaza.id,
              id_usuario_oficial: this.usuario_a_reasignar
                ? (this.usuario_a_reasignar.id_usuario || this.usuario_a_reasignar.iderp)
                : 0,
              id_trabajador_oficial: this.usuario_a_reasignar ? this.usuario_a_reasignar.id : 0,
              nombre_oficial: this.usuario_a_reasignar
                ? (this.usuario_a_reasignar.nombre_completo || this.usuario_a_reasignar.nombre_usuario)
                : '',
              nombre_usuario: this.usuarioReemplaza.nombre_completo || this.usuarioReemplaza.nombre_usuario,
              usuario_registro: this.getdatosUsuarioERPERP.iderp,
              es_reemplazo: !!this.usuario_a_reasignar
            });
            this.usuario_a_reasignar = null
            this.usuarioReemplaza    = null
            this.tipo                = null
            this.id_plantelSeccion   = null
            this.dialogReasignar     = false
            this.filaCoordinacion    = null
            this.noRepetidos         = []
            this.validarSuccess('Personal de extensión asignado');
          } catch (error) {
            this.validarError('Ocurrió un error al guardar el personal de la extensión');
          } finally {
            this.cargar = false;
            this.initialize()
          }
          return
        }

        const payload = {
          id_usuario_oficial: this.usuario_a_reasignar ? this.usuario_a_reasignar.id : 0,
          id_usuario_reemplaza: this.usuarioReemplaza.id,
          fecha: this.fecha,
          tipo: this.tipo,
          idplantel: this.id_plantelSeccion,
          usuario_creo: this.getdatosUsuarioERPERP.iderp,
          idreemplazos_coordinacion:  this.idreemplazos_coordinacion
        };

        this.cargar = true;

        try {
          // Si quieres debug:

          const { data } = await this.$http.post("coordi.reemplazo", payload);

          this.usuario_a_reasignar = null
          this.usuarioReemplaza    = null
          this.tipo                = null
          this.id_plantelSeccion   = null
          this.dialogReasignar     = false
          this.noRepetidos         = []

          // await this.initialize(); // si initialize es async, si no, igual funciona
          this.validarSuccess("Reemplazo guardado correctamente");
        } catch (error) {
          const msg = "Ocurrió un error al guardar el reemplazo"
          this.validarError(msg);
        } finally {
          this.cargar = false;
          this.initialize()
        }
      },

      async eliminarReemplazo( ){
        if (this.cargar) return;

        if (this.filaCoordinacion && this.filaCoordinacion.esExtension) {
          const id = this.usuario_a_reasignar && (
            this.usuario_a_reasignar.idplantel_extension_personal || this.usuario_a_reasignar.idreemplazos_coordinacion
          )
          this.cargar = true
          try {
            await this.$http.post('plantel.extension.personal.delete', {
              idplantel_extension_personal: id || null,
              quitar_reemplazo: !(this.usuario_a_reasignar && this.usuario_a_reasignar.es_extra),
              idplantel_extension: this.filaCoordinacion.idplantel_extension,
              tipo: this.tipo,
              id_trabajador: this.usuario_a_reasignar && this.usuario_a_reasignar.id,
              id_usuario: this.usuario_a_reasignar && (this.usuario_a_reasignar.id_usuario || this.usuario_a_reasignar.iderp)
            })
            this.usuario_a_reasignar = null
            this.usuarioReemplaza    = null
            this.tipo                = null
            this.id_plantelSeccion   = null
            this.dialogReasignar     = false
            this.filaCoordinacion    = null
            this.noRepetidos         = []
            this.validarSuccess('Reemplazo eliminado')
          } catch (error) {
            this.validarError('Ocurrió un error al quitar el personal de la extensión')
          } finally {
            this.cargar = false
            this.initialize()
          }
          return
        }

        this.cargar = true;

        try {
          // Si quieres debug:
          // console.log("payload reemplazo:", payload);

          const { data } = await this.$http.post("coordi.reemplazo.eliminar", this.usuario_a_reasignar);

          this.usuario_a_reasignar = null
          this.usuarioReemplaza    = null
          this.tipo                = null
          this.id_plantelSeccion   = null
          this.dialogReasignar     = false
          this.noRepetidos         = []

          // await this.initialize(); // si initialize es async, si no, igual funciona
          this.validarSuccess("Reemplazo guardado correctamente");
        } catch (error) {
          const msg = "Ocurrió un error al guardar el reemplazo"
          this.validarError(msg);
        } finally {
          this.cargar = false;
          this.initialize()
        }
      },

      asignarEncargada(
        usuario_a_reasignar,
        tipo,
        id_plantelSeccion,
        escuelaOP,
        idreemplazos_coordinacion,
        item = null,
        fila = null
       )
      {
        this.usuario_a_reasignar = usuario_a_reasignar
        this.tipo = tipo
        this.id_plantelSeccion = id_plantelSeccion
        this.escuelaOP = escuelaOP
        this.idreemplazos_coordinacion = idreemplazos_coordinacion
        this.filaCoordinacion = fila

        if( item ){

          this.filterEmpleados.map(fe => {
            fe.recepcionistaVesOP.map(rvo => {
              this.noRepetidos.push( rvo.id )
            })
          })

        }

        this.dialogReasignar = true;

      },

      getTeachersActivos( ){
      	this.cargar = true
      	this.teachers = []
        return this.$http.get('academico.teachers.activos').then(response=>{
          this.teachers = response.data
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      consultar () {
      	if( !this.ciclo ){
      		return this.validarErrorDirecto('Selecciona un ciclo por favor')
      	}

      	this.gruposRoles = []
      	this.cargar      = true
        this.$http.post('rol.clases', this.ciclo ).then(response=>{
          this.gruposRoles         = response.data.respuesta
        
          // this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      abrirEditarComentario (item) {
        this.plantelSeleccionadoComentario = item
        this.comentarioEditado = item.comentarios || ''
        this.dialogEditarComentario = true
      },

      guardarComentario () {
        if (!this.plantelSeleccionadoComentario) return

        const fecha = this.fecha
        const idplantel = this.plantelSeleccionadoComentario.idplantel
        const comentario = this.comentarioEditado

        if (this.plantelSeleccionadoComentario.esExtension) {
          this.dialogEditarComentario = false
          return
        }

        // Determinar si es crear o editar basado en si ya existe un comentario
        const tieneComentario = this.plantelSeleccionadoComentario.comentarios && 
                                this.plantelSeleccionadoComentario.comentarios.trim() !== ''

        const endpoint = tieneComentario 
          ? 'plantel.update.comentarios.corte'  // Si ya tiene comentario, actualizar
          : 'plantel.post.comentarios.corte'     // Si no tiene, crear nuevo

        this.cargar = true

        this.$http.post(endpoint, {
          fecha,
          idplantel,
          comentario
        }).then(() => {
          this.dialogEditarComentario = false
          this.initialize()
          this.validarSuccess('Comentario guardado correctamente')
        }).catch(error => {
          this.validarError(error.response.data.message)
        }).finally(() => {
          this.cargar = false
        })
      },

    },
  }
  /*454*/
  /* 1305 */
</script>
